const normalizeBaseUrl = value => value.replace(/\/$/, '');

function requireEnvVar(name) {
  const value = process.env[name];

  if (typeof value !== 'string' || value.trim().length === 0) {
    const message = `[FATAL] Missing required environment variable: ${name}. Set this in your .env/.env.local file and restart the app.`;
    console.error(message);
    throw new Error(message);
  }

  return normalizeBaseUrl(value.trim());
}

/** The BKFC CMS v1 API (bkfc-cms): every content, account, commerce and playback call. */
export const CMS_API_BASE_URL = requireEnvVar('REACT_APP_CMS_API_URL');

/**
 * The host for `/v1/auth/*` in cookie mode. It must be same-site with the web origin (prod
 * `https://api.bkfc.com`): the refresh cookie is host-only and SameSite=Lax, so a cross-site auth
 * host would never receive it. Every other v1 call stays on REACT_APP_CMS_API_URL with a Bearer.
 */
export const AUTH_V1_API_BASE_URL = requireEnvVar('REACT_APP_AUTH_API_URL_V1');
